import { Typography } from '@mui/material';
import InfoValueRow from '@shared/components/InfoValueRow';
import { currency } from '@shared/hooks/currencies';
import HorizontalSeparator from '@shared/pages/Flights/components/HorizontalSeparator';

const HotelPaymentDetails = ({
  total,
  isInUSD = false,
  currencyValue,
  chargesMessage,
}) => {
  return (
    <>
      <HorizontalSeparator color="#E5E5E5" />

      <InfoValueRow
        label="Total"
        value={total}
        isPrice
        boldLeft
        boldRight
        color="red"
        fontSize={{ xs: '17px', md: '18px', lg: '15px', xl: '16px' }}
        isInUSD={isInUSD}
      />

      {currencyValue && (
        <Typography
          sx={{
            fontSize: { xs: 12, md: 13 },
            alignSelf: 'start',
            lineHeight: 'normal',
          }}
        >
          Tipo de cambio: {currency(currencyValue)}
        </Typography>
      )}

      {chargesMessage && (
        <Typography
          sx={{
            fontSize: { xs: 12, md: 13 },
            alignSelf: 'start',
            lineHeight: 'normal',
          }}
        >
          Las tarifas publicadas no incluyen gastos administrativos.
        </Typography>
      )}
    </>
  );
};

export default HotelPaymentDetails;
